import { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";
import type { SheetPolylineGeometry, SheetTextGeometry } from "building-types/views/sheetGeometryTypes";
import { SheetGeometryType } from "building-types/views/sheetGeometryTypes";
import { aabb2Center } from "geom/aabb2";
import { polyLine2Move } from "geom/polyLine2";
import type { PlanCollider } from "./interiorLabelObstacle";
import type { GroupOfTaggedPlanGeometries, TaggedPlanGeometry } from "./planGeometrySourceTypes";

export function dimLineFromGroup(dimGroup: GroupOfTaggedPlanGeometries): SheetPolylineGeometry | undefined {
  return dimGroup.geometries.find((g) => g.category === SheetGeometryCategory.DIM_LINE) as SheetPolylineGeometry;
}

export function dimLabelFromGroup(dimGroup: GroupOfTaggedPlanGeometries): SheetTextGeometry | undefined {
  return dimGroup.geometries.find((g) => g.category === SheetGeometryCategory.DIM_LABEL) as SheetTextGeometry;
}

export function transformRelaxedSheetTextGeometry(
  label: PlanCollider,
): (SheetTextGeometry & Required<Pick<SheetTextGeometry, "category">>) | undefined {
  const [newX, newY] = aabb2Center(label.labelAABB);
  if (!label.planTextGeomSource) {
    return undefined;
  }

  return { ...label.planTextGeomSource, x: newX, y: newY };
}

export function transformRelaxedDimensionGroup(label: PlanCollider): TaggedPlanGeometry[] {
  const result: TaggedPlanGeometry[] = [];
  const [newX, newY] = aabb2Center(label.labelAABB);
  const { dimensionLine, dimensionLineUnrelaxed } = label;

  if (!dimensionLine || !dimensionLineUnrelaxed) {
    console.warn("Dimension line or dimension line unrelaxed is missing");
    return [];
  }

  const dx = dimensionLine[0] - dimensionLineUnrelaxed[0];
  const dy = dimensionLine[1] - dimensionLineUnrelaxed[1];

  for (const geom of label?.dimPlanGeomSource?.geometries ?? []) {
    const { type } = geom;
    switch (type) {
      case SheetGeometryType.TEXT: {
        result.push({
          ...geom,
          x: newX,
          y: newY,
        });
        break;
      }
      case SheetGeometryType.POLYLINE: {
        result.push({
          ...geom,
          paths: geom.paths.map((pl) => polyLine2Move(pl, dx, dy)),
        });
        break;
      }
      default:
        break;
    }
  }

  return result;
}
